import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import Breadcrumb from "../../components/Breadcrumb";
import Button from "../../components/Button";

import signinImg from "../../assets/img/contact/signin.jpg";
import iconImg from "../../assets/img/contact/Icon.png";

const LoginMain = ({ setUserId }) => {
  const navigate = useNavigate();

  // Controlled inputs state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Loading and error states
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Login function called on form submit
  const handleLogin = async (e) => {
    e.preventDefault(); // prevent default form submit
    setLoading(true);
    setError("");

    try {
      const res = await axios.post("https://ricgop.online/api/login.php", {
        email,
        password,
      });
      if (res.data.success) {
        if (setUserId) setUserId(res.data.userId);
        navigate("/dashboard");
      } else {
        setError("Invalid email or password");
      }
    } catch (err) {
      setError("Network error. Please try again later.");
    }
    setLoading(false);
  };

  return (
    <main>
      <Breadcrumb title="Login" />

      <div className="it-signup-area pt-120 pb-120">
        <div className="container">
          <div className="it-signup-bg p-relative">
            <div className="it-signup-thumb d-none d-lg-block">
              <img src={signinImg} alt="Sign in" />
            </div>
            <div className="row">
              <div className="col-xl-6 col-lg-6">
                <form onSubmit={handleLogin}>
                  <div className="it-signup-wrap">
                    <h4 className="it-signup-title">Sign In</h4>

                    {error && (
                      <div className="mb-4 text-red-600 font-medium">{error}</div>
                    )}

                    <div className="it-signup-input-wrap">
                      <div className="it-signup-input mb-20">
                        <input
                          type="email"
                          placeholder="Email *"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          autoComplete="username"
                          disabled={loading}
                        />
                      </div>
                      <div className="it-signup-input mb-20">
                        <input
                          type="password"
                          placeholder="Password *"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          autoComplete="current-password"
                          disabled={loading}
                        />
                      </div>
                    </div>

                    <div className="it-signup-forget d-flex justify-content-between flex-wrap">
                      <a className="mb-20" href="#">
                        Forgot Password?
                      </a>
                      <div className="it-signup-agree mb-20">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                            disabled={loading}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault"
                          >
                            Remember me
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="it-signup-btn d-sm-flex justify-content-between align-items-center mb-40">
                      <button
                        type="submit"
                        className="it-btn-theme mr-30"
                        disabled={loading}
                      >
                        <Button btnText={loading ? "Logging in..." : "Sign In"} />
                      </button>
                      <div className="it-signup-link">
                        <span>or sign up with</span>
                        <a href="#">
                          <img src={iconImg} alt="Social sign in" />
                        </a>
                      </div>
                    </div>

                    <div className="it-signup-text">
                      <span>
                        Don't have an account? <Link to="/register">Sign Up</Link>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default LoginMain;
